/**
 * SearchParams
 *
 * Module that handles the applications current search parameters
 *
 * @return {type}
 */

OT.createNS('OT.Search.Params');

OT.Search.Params = (function() {

    var searchParams = OT.Search.Helpers.buildSearchParameters.build(
        OT.Search.Data.get().Request,
        OT.Search.Data.get().DomainCulture
    );

    var get = function(key) {
        if(!key) {
            return searchParams;
        }

        if(!_.has(searchParams, key.toLowerCase())) {
            return null;
        }

        return searchParams[key.toLowerCase()];
    };

    var getAll = function() {
        return searchParams;
    };

    var set = function(key, val) {
        if(key === undefined && val === undefined) {
            throw new Error('SearchParams: No parameters passed');
        }

        if(val !== null && val !== undefined) {
            searchParams[key.toLowerCase()] = val;
            return true;
        }

        _.each(key, function(v, k) {
            if(v === null || v === undefined || v.length === 0) {
                delete searchParams[k.toLowerCase()];
            } else {
                searchParams[k.toLowerCase()] = v;
            }
        });

        return this;
    };

    var remove = function(arr) {
        var args = (arr && arr instanceof Array) ? arr : [].slice.call(arguments);

        _.each(args, function(key) {
            delete searchParams[key.toLowerCase()];
        });
    };

    var clear = function(clearAll) {
        searchParams = {};
        // Allow for chaining
        return this;
    };

    var areObjectsEqual = function(obj1) {
        var obj2 = OT.Search.Params.getAll(),
            arr  = [obj1, obj2];

        _.each(arr, function(obj) {
            _.each(obj, function(val, key) {
                if(val instanceof Array) {
                    obj[key] = val.join(',');
                }
            });
        });

        return _.isEqual(obj1, obj2);
    };

    OT.Events.on('testObject:updated', function(e, tests) {
        set('tests', tests);
    });

    return {
        get: get,
        getAll: getAll,
        isEqual: areObjectsEqual,
        set: set,
        remove: remove,
        clear: clear
    };

})();
